import React, { Component } from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import styles from './styles.scss'
import { compose } from 'recompose'
import {
    Table,
    TableHead,
    TableRow,
    TableCell
} from 'react-toolbox'
import { NVQUAL_TESTS, NVQUAL_TEST_CATEGORIES } from 'containers/NvqualReport/constants'
import T from 'i18n-react'

import { Link } from 'react-scroll'

class TestSummaryEnterprise extends Component {

    renderResultCell(result) {
        if (result == "Pass") {
            return <code className={styles.green}>{result}</code>
        } else if (result == "Skipped") {
            return <code className={styles.yellow}>{result}</code>
        } else {
            return <code className={styles.red}>{result}</code>
        }
    }

    renderTableRow(tests) {
        return tests.map((testData, idx) => {
            const testName = T.translate(`containers.project.nvqualSection.test.${testData.testName}`);
            return (
                <TableRow key={idx}>
                    <TableCell key={`testName${testData.category}${idx}`} className={styles.testNameCell}>
                        {testData.result != "Skipped" ? <Link activeClass="active" to={testData.testName} spy={true} smooth={true} offset={0} duration={200} containerId="scrollContainer">
                            <span className={styles.link}>{testName}</span>
                        </Link> : <span>{testName}</span>}
                    </TableCell>
                    <TableCell key={`result${testData.category}${idx}`} className={styles.testResultCell}>
                        {this.renderResultCell(testData.result)}
                    </TableCell>
                </TableRow>
            )
        })
    }

    renderTableHead() {
        return (
            <TableHead key={`head`}>
                <TableCell key={`testName`}>Test Name</TableCell>
                <TableCell key={`result`}>Result</TableCell>
            </TableHead>
        )
    }

    renderTestCategory(testCategory, tests) {
        const filteredTests = tests.filter(test => test.category === testCategory);
        return (
            <div>
                <h5 className={styles.testCategoryHeader}>{testCategory}</h5>
                <Table selectable={false}>
                    {this.renderTableHead()}
                    {this.renderTableRow(filteredTests)}
                </Table>
            </div>
        )
    }

    render() {
        const { tests } = this.props
        
        return (
            <div>
                {NVQUAL_TEST_CATEGORIES.map((category) => {
                    let filteredTests = tests.filter(test => test.category === category);

                    // order the tests in the test category by the test order specified in the nvqual_tests array
                    filteredTests.sort((a, b) => {
                        const indexA = NVQUAL_TESTS.indexOf(a.testName);
                        const indexB = NVQUAL_TESTS.indexOf(b.testName);

                        return indexA - indexB;
                    })

                    if (filteredTests.length > 0) {
                        return this.renderTestCategory(category, filteredTests);
                    }
                    return null;
                })}
            </div>
        )
    }
}

const withStyles = CSSModules(styles)
const enhance = compose(withStyles)
export default enhance(TestSummaryEnterprise)